import ModelInterface from 'src/models/ModelInterface'
import {RawNewsfeed} from '@/types/entity/RawNewsfeed'
import store from '@/store/index'

class Newsfeed extends ModelInterface<RawNewsfeed> {

  constructor (data: RawNewsfeed) {
    super(data)
  }

  public getTitle () {
    return this.data.title
  }

  public getDescr () {
    return this.data.descr
  }

  public getForAll () {
    return this.data.for_all
  }
}

export default Newsfeed
